import { Add, Delete, Percent } from "@mui/icons-material";
import { TableContainer, Paper, Table, TableBody, TableHead, TableRow, TableCell, Stack, Button, Box, IconButton, Divider } from "@mui/material";
import { useState } from "react";
import ProductForm from "./ProductForm";
import DiscountForm from "./DiscountForm";

export default function Detail({order, edit, onChange}){

    const [form, setForm] = useState(false)

    const [discountForm, setDiscountForm] = useState(false)

    const handleProduct = p => {
        let copy = JSON.parse(JSON.stringify(order));
        copy.products.push(p);
        onChange(copy);
        setForm(false);
    }

    const handleDiscount = percentOff => {
        let copy = JSON.parse(JSON.stringify(order));
        if(percentOff < 1 || percentOff > 99){
            delete copy.percentOff
        }else{
            copy.percentOff = percentOff;
        }
        onChange(copy);
        setDiscountForm(false);
    }

    const handleDelete = id => {
        
        if(!window.confirm("Êtes-vous sûr de vouloir supprimer cet article ?")) return false;
        
        let copy = JSON.parse(JSON.stringify(order));
        copy.products = copy.products.filter(p => p.id !== id)
        onChange(copy);
        setForm(false);
    }

    const formatNumber = number => parseFloat(number.toFixed(2)).toLocaleString()

    const percentOff = order.percentOff || 0

    const amount = order.products.map(p => p.price * p.quantity * ((100 - percentOff) / 100)).reduce((a,b) => a + b, 0)

    const discount = order.products.map(p => p.price * p.quantity * percentOff / 100).reduce((a,b) => a + b, 0)

    const tax = order.products.map(p => p.price * p.quantity * ((100 - percentOff) / 100) * p.taxRate).reduce((a,b) => a + b, 0)

    const total = amount + tax

    return <Stack spacing={2}>

        {(!form && !discountForm) && <>

            <TableContainer component={Paper} variant='outlined'>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Désignation</TableCell>
                            <TableCell>PU HT</TableCell>
                            <TableCell>Quantité</TableCell>
                            <TableCell>Montant</TableCell>
                            <TableCell>TVA</TableCell>
                            {edit && <TableCell></TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>

                        {order?.products?.map(p => 
                            <TableRow key={p.id}>
                                <TableCell>{p.title}</TableCell>
                                <TableCell>{formatNumber(p.price)}€</TableCell>
                                <TableCell>{p.quantity}</TableCell>
                                <TableCell>{formatNumber(p.price * p.quantity)}€</TableCell>
                                <TableCell>{formatNumber(p.taxRate * 100)}%</TableCell>
                                {edit && <TableCell align='right'>
                                    <IconButton size='small' onClick={() => handleDelete(p.id)}>
                                        <Delete />
                                    </IconButton>
                                </TableCell>}
                            </TableRow>
                        )}

                        {percentOff > 0 && 
                            <TableRow>
                                <TableCell>Remise {percentOff}%</TableCell>
                                <TableCell>-{formatNumber(discount)}€</TableCell>
                                <TableCell>1</TableCell>
                                <TableCell>-{formatNumber(discount)}€</TableCell>
                                <TableCell>0%</TableCell>
                                {edit && <TableCell align='right'>
                                    <IconButton size='small' onClick={() => handleDiscount(0)}>
                                        <Delete />
                                    </IconButton>
                                </TableCell>}
                            </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>

            {edit && <Stack>

                <Button 
                    startIcon={<Add />}
                    onClick={() => setForm(true)}
                >
                    Ajouter un article
                </Button>

                <Button 
                    startIcon={<Percent />} 
                    onClick={() => setDiscountForm(true)}
                    color='warning'
                >  
                    Ajouter une remise
                </Button>

            </Stack>}

            <Stack alignItems='flex-end'>

                <Stack spacing={2} width={250}>

                    <Stack direction='row' justifyContent='space-between'>
                        <Box>Total HT</Box>
                        <Box>{formatNumber(amount)}€</Box>
                    </Stack>

                    <Divider/>

                    <Stack direction='row' justifyContent='space-between'>
                        <Box>TVA</Box>
                        <Box>{formatNumber(tax)}€</Box>
                    </Stack>

                    <Divider/>

                    <Stack direction='row' justifyContent='space-between'>
                        <Box>Total TTC</Box>
                        <Box>{formatNumber(total)}€</Box>
                    </Stack>

                </Stack>

            </Stack>

        
        </>}

        {form && 
            <ProductForm 
                onSubmit={handleProduct}
                onCancel={() => setForm(false)}
            />
        }

        {discountForm && 
            <DiscountForm
                value={percentOff}
                onSubmit={handleDiscount}
                onCancel={() => setDiscountForm(false)}
            />
        }

    </Stack> 
}